// extracted by mini-css-extract-plugin
export default {"base":"EditCategories_base__1IJRX","label":"EditCategories_label__tyvSt","field":"EditCategories_field__JUNF6","tags":"EditCategories_tags__o9JTY","tag":"EditCategories_tag__ZF07x"};